import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import FormLabel from '../../../../components/atoms/FormLabel';
import FormInput from '../../../../components/atoms/FormInput';

const StyledInput = styled(FormInput)`
  max-width: 250px;
`;

const ContactInput = (props) => {
  const {
    label,
    type,
    value,
    onChange,
    disabled,
    name,
  } = props;

  return (
    <div>
      <FormLabel label={label} />
      <br />
      <StyledInput
        type={type}
        value={value}
        onChange={onChange}
        disabled={disabled}
        name={name}
        className="form-control"
      />
    </div>
  );
};

ContactInput.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['email', 'phone']).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

ContactInput.defaultProps = {
  disabled: false,
};

export default ContactInput;
